define('widgets/paymentMethodSelector/viewmodel',['knockout', 'underscore'], function (ko, _) {

    var PaymentMethodSelector = function(dialog, ChooseMethodDialog) {
        this.ChooseMethodDialog = ChooseMethodDialog;
        this.dialog = dialog;
    };

    PaymentMethodSelector.prototype.activate = function(settings) {
        var self = this;
        self.title = settings.title;
        self.selectionTextGenerator = settings.selectionTextGenerator || _.identity;
        self.availableMethods = settings.availableMethods || ko.observableArray([]);
        self.savedMethods = settings.savedMethods || ko.observableArray([]);
        self.selectedMethod = settings.selectedMethod || ko.observable();
        self.onCreate = settings.onCreate || function() {};
        self.selectionText = ko.deferredComputed(function () {
            return self.selectionTextGenerator(self.selectedMethod.property('name'))();
        });
    };

    PaymentMethodSelector.prototype.open = function() {
        var self = this;
        self.dialog.showDialog(new self.ChooseMethodDialog(this.savedMethods, this.availableMethods, this.selectedMethod, this.title, this.selectionTextGenerator)).then(function(action, method) {
            if (action === 'create') {
                self.onCreate(method);
            }
        });
    };

    PaymentMethodSelector.prototype.attached = function(view, parent) {
        // add class to container so we can have some global control over its dimensions
        parent.classList.add('payment-method-selector-container');
    };

    return PaymentMethodSelector;
});


